import { Subscription } from 'rxjs';
import { SeoService } from './../../../shared/services/seo/seo.service';
import { MatDialog } from '@angular/material/dialog';
import { UtilService } from './../../../shared/services/util/util.service';
import { HomepageService } from './../../services/homepage.service';
import { StorageService } from './../../../shared/services/storage/storage.service';
import { Component, OnInit, OnDestroy, Inject, PLATFORM_ID, Renderer2, HostListener } from '@angular/core';
import { EventsService, VariablesService, VwoService } from '../../../shared/services';
import { isPlatformBrowser, DOCUMENT } from '@angular/common';
import { ExitIntentComponent } from '../../../common/exit-intent/components/exit-intent/exit-intent.component';
import { environment } from '../../../../environments/environment';
@Component({
  selector: 'app-homepage-main',
  templateUrl: './main.component.html',
  styleUrls: ['./main.component.scss']
})
export class HomepageMainComponent implements OnInit, OnDestroy {
  ExitlistenerFn: () => void;
  isLoggedIn: boolean;
  draftData;
  componentInView = {
    'what-we-offer': false,
    'trending': false,
    'crowdfunding': false,
    'successtories': false,
    'featuredin': false,
    'causes': false,
    'get-started': false,
    'fundraisingFeature': false,
    'footer': false,
    'sacflow': false
  };
  metaData;
  isLoginPopUpOpen = false;
  mouseY = 0;
  popupCounter = 0;
  isSipSubscribed = false;

  subs: Subscription[] = [];
  userData;
  isMobile;

  constructor(
    public storageService: StorageService,
    public homepageService: HomepageService,
    public utilService: UtilService,
    public dialog: MatDialog,
    private seoService: SeoService,
    private eventsService: EventsService,
    private variablesService: VariablesService,
    @Inject(PLATFORM_ID) private platformId: Object,
    @Inject(DOCUMENT) private document: any,
    public vwo: VwoService,
    private renderer: Renderer2
  ) { }

  ngOnInit() {
    this.isMobile = this.utilService?.isMobile();
    this.sipMcdRedirectUser();
    this.utilService.scrollToTop();
    this.addReviewSchema();
    this.variablesService.pageName = 'home';
    this.loadSeoData();
    if (isPlatformBrowser(this.platformId)) {
      this.pageViewEvent();
    }
    this.variablesService.mainLayoutConfig.next({
      showHeader: true,
      showFooter: true,
      showMenus: true,
      showProfile: true,
      showSearch: true,
      logoNavigate: true,
      animateHeader: true,
      headerClass: 'homepage-header white-bg download-app-banner',
      showCurrency: false,
      showWhatsapp: true,
      zendesk: true,
      showFooterSEO: true
    });
    if (typeof document !== 'undefined') {
      this.document.body.classList.add('homePage');
    }
    // this.ExitlistenerFn = this.exitIntent();
    this.seoService.updateCanonicalURL('');

    this.subs.push(this.variablesService.userData.subscribe(res => {
      this.userData = res;
    }));

  }

  sipMcdRedirectUser() {
    this.subs.push(this.variablesService.userData.subscribe({
      next: (res) => {
        this.isSipSubscribed = res?.listsubscriptions?.medical?.status_flag?.toString().match('1|2|3|4') ? true : false;
        const userData = this.storageService.get('user');

        if ((userData && userData?.user?.user_type === 'campaigner'
          && userData?.all_active_campaigns
          && userData?.all_active_campaigns?.length > 0)) {

          this.utilService.nativeNavigation(environment.manage_domain + '/manage/list');
        } else if (this.isSipSubscribed) {
          if (!this.storageService.getFromSession('sipUserRedirect')) {
            let url = environment.sipretention_domain;
            if (res?.listsubscriptions?.medical?.status_flag?.toString().match('2|4|5')) {
              url += '/inactiveuser';
            }
            this.storageService.addSessionData('sipUserRedirect', true);
            this.utilService.nativeNavigation(url);
          }
        }
      }
    }));
  }

  addReviewSchema() {
    const reviewSchema = {
      '@context': 'http://schema.org',
      '@type': 'Product',
      'name': 'Crowdfunding India - Best Crowdfunding Platform & Website - Ketto',
      'description': 'Ketto is an Online Crowdfunding Platform and Website in India for fundraising of Social, Charity, Movies, Music, Personal and Creative causes. Visit us online!',
      'brand':
      {
        '@type': 'Thing',
        'name': 'Ketto.Org'
      },
      'aggregateRating':
      {
        '@type':
          'AggregateRating',
        'ratingValue':
          '4.5',
        'reviewCount':
          '599'
      }
    };
    this.seoService.schemaOrgObject(reviewSchema, 'homeReview');
  }


  private loadSeoData() {
    this.metaData = this.seoService.homePageMetaTags();
    this.seoService.addMetaTags(this.metaData);
    this.seoService.meta.addTag({ name: 'google-site-verification', content: 'SqBykoY6M4bEc03AHmT_XSd3U51D3Kw0NRX_xXM5zXc' });
    this.seoService.meta.addTag({ name: 'google-site-verification', content: 'sUJxGJTW80o5MNVMSx9h3UwvwVKUrXzbmuS-yaXlZV0' })
    this.seoService.schemaOrgObject(this.seoService.schema.home_org);
    this.seoService.schemaOrgObject(this.seoService.schema.home_webpage);
    this.utilService.setPageTitle(`Ketto: Crowdfunding India | #1 Crowdfunding Website for Fundraising`);

  }

  ngOnDestroy() {
    this.seoService.removeMetaTags(this.metaData);
    if (typeof document !== 'undefined') {
      this.document.body.classList.remove('homePage');
    }
    if (this.ExitlistenerFn) {
      this.ExitlistenerFn();
    }
    this.subs.forEach(sub => sub.unsubscribe());
  }

  pageViewEvent() {
    const pageViewPayload = {
      eventName: 'pageView',
      page_name: 'home',
      referrer_page: this.document.referrer
    };
    const urlParams = this.utilService.getUrlParams();
    const payload = { ...pageViewPayload, ...urlParams };
    this.eventsService.onLoadSystemEvent(payload);
  }

  loadComponent(e, component) {
    if (e.visible === true && this.componentInView[component] === false) {
      this.componentInView[component] = true;
    }
  }

  /*Exit Intent Popup */
  openDialog(): void {
    const dialogRef = this.dialog.open(ExitIntentComponent, {
      width: '540px',
      maxHeight: this.utilService.isMobile() ? '100vh' : '524px',
      panelClass: 'exit-intent-dialog'
    });
  }

  exitIntent() {
    return this.renderer.listen('document', 'mouseout', (event) => {
      if (event.toElement == null && event.relatedTarget == null && event.clientY < 0) {
        if (this.popupCounter < 1 && this.storageService.getFromSession('exitDialog') !== 'shown') {
          this.openDialog();
          this.storageService.addSessionData('exitDialog', 'shown');

        }
        this.popupCounter++;
      }
    });
  }
}
